import { render, staticRenderFns } from "./NaoAutorizado.vue?vue&type=template&id=785263ec&"
import script from "./NaoAutorizado.vue?vue&type=script&lang=js&"
export * from "./NaoAutorizado.vue?vue&type=script&lang=js&"
import style0 from "./NaoAutorizado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports